module.exports = __webpack_public_path__ + "static/media/Rhydon_gaussian2.3f796e1f.png";